import { Empty, Flex, Skeleton } from "antd";
import { useGetShiftDetailsQuery } from "../../../../../../app/features/employee/emp-attendance/emp-attendance.api";
import useError from "../../../../../../hooks/useError";
import { formatTo12Hour } from '@/utils';

type ShiftInfoProps = {
  shiftId: string;
};

export default function ShiftInfo({ shiftId }: ShiftInfoProps) {
  const { isLoading, isFetching, error, data } = useGetShiftDetailsQuery(
    shiftId,
    {
      skip: !shiftId,
    }
  );
  useError(error, "Failed to fetch shift details");

  const loading = isLoading || isFetching;
  const shiftData = data?.data;

  if (loading) {
    return (
      <div className="border-b border-theme-gray-700 pb-4 mb-4">
        <Flex justify="space-between" align="center" wrap>
          <div className="flex-1">
            <Skeleton.Input active size="large" className="!w-32" />
          </div>
          <div className="flex-1 text-center">
            <Skeleton.Input active size="large" className="!w-32" />
          </div>
        </Flex>
        <Flex justify="space-between" align="center" wrap className="mt-8">
          <div className="flex-1">
            <Skeleton.Input active size="large" className="!w-32" />
          </div>
          <div className="flex-1 text-center">
            <Skeleton.Input active size="large" className="!w-32" />
          </div>
        </Flex>
      </div>
    );
  }

  if (!shiftData) {
    return (
      <div className="border-b border-theme-gray-700 pb-4 mb-4">
        <Empty />
      </div>
    );
  }

  return (
    <div className="border-b border-theme-gray-700 pb-4 mb-4">
      <Flex justify="space-between" align="center" wrap>
        <ShiftItem label="Shift Name" value={shiftData.name} />
        <ShiftItem
          label="End time"
          value={formatTo12Hour(shiftData.endTime)}
          className="min-w-28"
        />
      </Flex>
      <Flex justify="space-between" align="center" wrap className="mt-8">
        <ShiftItem
          label="Start Time"
          value={formatTo12Hour(shiftData.startTime)}
        />
        <ShiftItem
          label="Grace Period"
          value={`${shiftData.checkInGracePeriod} Min`}
          className="min-w-28"
        />
      </Flex>
    </div>
  );
}

type ItemProps = {
  label: string;
  value: string;
  className?: string;
};

const ShiftItem = ({ label, value, className = "" }: ItemProps) => (
  <div className={className}>
    <h6 className="dark:text-white text-lg capitalize mb-3">{label}</h6>
    <h5 className="dark:text-white text-xl font-bold capitalize">{value}</h5>
  </div>
);
